/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SurfaceSocialConnection } from './SurfaceSocialConnection';
import {
    SurfaceSocialConnectionFromJSON,
    SurfaceSocialConnectionFromJSONTyped,
    SurfaceSocialConnectionToJSON,
    SurfaceSocialConnectionToJSONTyped,
} from './SurfaceSocialConnection';
import type { EarningConfigValues } from './EarningConfigValues';
import {
    EarningConfigValuesFromJSON,
    EarningConfigValuesFromJSONTyped,
    EarningConfigValuesToJSON,
    EarningConfigValuesToJSONTyped,
} from './EarningConfigValues';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { SurfaceAllowedGame } from './SurfaceAllowedGame';
import {
    SurfaceAllowedGameFromJSON,
    SurfaceAllowedGameFromJSONTyped,
    SurfaceAllowedGameToJSON,
    SurfaceAllowedGameToJSONTyped,
} from './SurfaceAllowedGame';
import type { LedgerOwner } from './LedgerOwner';
import {
    LedgerOwnerFromJSON,
    LedgerOwnerFromJSONTyped,
    LedgerOwnerToJSON,
    LedgerOwnerToJSONTyped,
} from './LedgerOwner';
import type { SurfaceContentBlock } from './SurfaceContentBlock';
import {
    SurfaceContentBlockFromJSON,
    SurfaceContentBlockFromJSONTyped,
    SurfaceContentBlockToJSON,
    SurfaceContentBlockToJSONTyped,
} from './SurfaceContentBlock';
import type { SurfaceThemeConfig } from './SurfaceThemeConfig';
import {
    SurfaceThemeConfigFromJSON,
    SurfaceThemeConfigFromJSONTyped,
    SurfaceThemeConfigToJSON,
    SurfaceThemeConfigToJSONTyped,
} from './SurfaceThemeConfig';
import type { SurfaceStatus } from './SurfaceStatus';
import {
    SurfaceStatusFromJSON,
    SurfaceStatusFromJSONTyped,
    SurfaceStatusToJSON,
    SurfaceStatusToJSONTyped,
} from './SurfaceStatus';
import type { SurfaceVisibility } from './SurfaceVisibility';
import {
    SurfaceVisibilityFromJSON,
    SurfaceVisibilityFromJSONTyped,
    SurfaceVisibilityToJSON,
    SurfaceVisibilityToJSONTyped,
} from './SurfaceVisibility';
import type { DropSiblingTitle } from './DropSiblingTitle';
import {
    DropSiblingTitleFromJSON,
    DropSiblingTitleFromJSONTyped,
    DropSiblingTitleToJSON,
    DropSiblingTitleToJSONTyped,
} from './DropSiblingTitle';
import type { SurfacePointSystemConfig } from './SurfacePointSystemConfig';
import {
    SurfacePointSystemConfigFromJSON,
    SurfacePointSystemConfigFromJSONTyped,
    SurfacePointSystemConfigToJSON,
    SurfacePointSystemConfigToJSONTyped,
} from './SurfacePointSystemConfig';
import type { DropMode } from './DropMode';
import {
    DropModeFromJSON,
    DropModeFromJSONTyped,
    DropModeToJSON,
    DropModeToJSONTyped,
} from './DropMode';
import type { DropSection } from './DropSection';
import {
    DropSectionFromJSON,
    DropSectionFromJSONTyped,
    DropSectionToJSON,
    DropSectionToJSONTyped,
} from './DropSection';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { DropRelease } from './DropRelease';
import {
    DropReleaseFromJSON,
    DropReleaseFromJSONTyped,
    DropReleaseToJSON,
    DropReleaseToJSONTyped,
} from './DropRelease';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { DropStorefront } from './DropStorefront';
import {
    DropStorefrontFromJSON,
    DropStorefrontFromJSONTyped,
    DropStorefrontToJSON,
    DropStorefrontToJSONTyped,
} from './DropStorefront';
import type { DropCampaignWindow } from './DropCampaignWindow';
import {
    DropCampaignWindowFromJSON,
    DropCampaignWindowFromJSONTyped,
    DropCampaignWindowToJSON,
    DropCampaignWindowToJSONTyped,
} from './DropCampaignWindow';
import type { DerivedGameResponse } from './DerivedGameResponse';
import {
    DerivedGameResponseFromJSON,
    DerivedGameResponseFromJSONTyped,
    DerivedGameResponseToJSON,
    DerivedGameResponseToJSONTyped,
} from './DerivedGameResponse';
import type { StreamingSettings } from './StreamingSettings';
import {
    StreamingSettingsFromJSON,
    StreamingSettingsFromJSONTyped,
    StreamingSettingsToJSON,
    StreamingSettingsToJSONTyped,
} from './StreamingSettings';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { Distribution } from './Distribution';
import {
    DistributionFromJSON,
    DistributionFromJSONTyped,
    DistributionToJSON,
    DistributionToJSONTyped,
} from './Distribution';
import type { SurfaceMeta } from './SurfaceMeta';
import {
    SurfaceMetaFromJSON,
    SurfaceMetaFromJSONTyped,
    SurfaceMetaToJSON,
    SurfaceMetaToJSONTyped,
} from './SurfaceMeta';
import type { DropType } from './DropType';
import {
    DropTypeFromJSON,
    DropTypeFromJSONTyped,
    DropTypeToJSON,
    DropTypeToJSONTyped,
} from './DropType';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';
import type { RosterFieldSpec } from './RosterFieldSpec';
import {
    RosterFieldSpecFromJSON,
    RosterFieldSpecFromJSONTyped,
    RosterFieldSpecToJSON,
    RosterFieldSpecToJSONTyped,
} from './RosterFieldSpec';
import type { DropVideo } from './DropVideo';
import {
    DropVideoFromJSON,
    DropVideoFromJSONTyped,
    DropVideoToJSON,
    DropVideoToJSONTyped,
} from './DropVideo';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * Creator/community top-level page entity. Sibling of Hub (brand).
 * @export
 * @interface Drop
 */
export interface Drop {
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    id: string;
    /**
     * Inlined rather than $ref'd to TimeStamps — a second bare $ref inside allOf makes the generator silently drop one, and the dropped fields vanish from the generated client type.
     * @type {number}
     * @memberof Drop
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof Drop
     */
    updatedAt?: number;
    /**
     * URL-friendly identifier (e.g., "aydan")
     * @type {string}
     * @memberof Drop
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    description?: string;
    /**
     * 
     * @type {DropType}
     * @memberof Drop
     */
    dropType: DropType;
    /**
     * 
     * @type {SurfaceStatus}
     * @memberof Drop
     */
    status: SurfaceStatus;
    /**
     * 
     * @type {SurfaceVisibility}
     * @memberof Drop
     */
    visibility?: SurfaceVisibility;
    /**
     * Standalone surface — private, or absent from the directory. Derived from visibility + distributions by isListed.
     * @type {boolean}
     * @memberof Drop
     */
    isStandalone?: boolean;
    /**
     * How this surface is served per channel, and the style it renders in there.
     * @type {Array<Distribution>}
     * @memberof Drop
     */
    distributions?: Array<Distribution>;
    /**
     * 
     * @type {boolean}
     * @memberof Drop
     */
    verified?: boolean;
    /**
     * Owner user/organization ID
     * @type {string}
     * @memberof Drop
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    ownerType?: DropOwnerTypeEnum;
    /**
     * Entity assignment (portal D1) — which org entity's staff reach this Drop. BRAND is the only assignable entity class today.
     * @type {string}
     * @memberof Drop
     */
    entityType?: DropEntityTypeEnum;
    /**
     * The assigned entity's id (a Brand today). Distinct from ownerId — assignment grants staff reach, not ownership.
     * @type {string}
     * @memberof Drop
     */
    entityId?: string;
    /**
     * Pointer to the connected store's Merchant record. All connection state lives on the Merchant; the host holds only this id.
     * @type {string}
     * @memberof Drop
     */
    shopMerchantId?: string;
    /**
     * Overwolf game IDs associated with this Drop
     * @type {Array<string>}
     * @memberof Drop
     */
    games?: Array<string>;
    /**
     * 
     * @type {Array<SurfaceSocialConnection>}
     * @memberof Drop
     */
    socials?: Array<SurfaceSocialConnection>;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    creatorProfileImageUrl?: string;
    /**
     * When true, admin/creator has manually uploaded an avatar. Refresh / cron MUST skip this field.
     * @type {boolean}
     * @memberof Drop
     */
    creatorProfileImageManualOverride?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    creatorHeaderImageUrl?: string;
    /**
     * When true, banner has been manually overridden — refresh skips.
     * @type {boolean}
     * @memberof Drop
     */
    creatorHeaderImageManualOverride?: boolean;
    /**
     * Denormalised thumbnail of the creator's most recent VOD / past broadcast / highlight on their primary streaming platform. Used as a richer fallback than `creatorHeaderImageUrl` when the directory needs a non-live cover image.
     * @type {string}
     * @memberof Drop
     */
    lastVodThumbnailUrl?: string;
    /**
     * Uploaded icon asset id. Returned so the editor can show and replace it; the resolved URL is creatorProfileImageUrl.
     * @type {string}
     * @memberof Drop
     */
    iconImageId?: string;
    /**
     * Uploaded wordmark asset id. Returned so the editor can show and replace it; the resolved URL is logoImageUrl.
     * @type {string}
     * @memberof Drop
     */
    logoImageId?: string;
    /**
     * Wide wordmark lockup, rendered as the hero's logo. Distinct from the square icon in creatorProfileImageUrl.
     * @type {string}
     * @memberof Drop
     */
    logoImageUrl?: string;
    /**
     * One line under the name. True whether or not anything is launching.
     * @type {string}
     * @memberof Drop
     */
    tagline?: string;
    /**
     * Authored name of the enclosing program, shown as the bar's wordmark beside the brand lockup. Display copy only.
     * @type {string}
     * @memberof Drop
     */
    programName?: string;
    /**
     * What this surface calls its members, as a stat label. Authored copy; consumers default to "Members".
     * @type {string}
     * @memberof Drop
     */
    memberStatLabel?: string;
    /**
     * The qualifier under the member count — "Worldwide", "Joined". Authored copy; consumers default to "Joined".
     * @type {string}
     * @memberof Drop
     */
    memberStatDetail?: string;
    /**
     * Distinct participants in this Drop's ledger; the relationship count only when it feeds none. Computed by the slug route; absent on list responses.
     * @type {number}
     * @memberof Drop
     */
    memberCount?: number;
    /**
     * What this Drop is about, in its own words.
     * @type {string}
     * @memberof Drop
     */
    synopsis?: string;
    /**
     * Where a visitor buys or plays. The CTA wording changes with release status; this destination does not.
     * @type {string}
     * @memberof Drop
     */
    purchaseUrl?: string;
    /**
     * The feature video.
     * @type {string}
     * @memberof Drop
     */
    trailerUrl?: string;
    /**
     * The strip under the feature trailer. Empty means the hero falls back to the connected YouTube channel.
     * @type {Array<DropVideo>}
     * @memberof Drop
     */
    videos?: Array<DropVideo>;
    /**
     * The slim rail under the hero — modes and beta milestones pre-launch, the season cadence after. True of a franchise with no launch at all.
     * @type {Array<DropMode>}
     * @memberof Drop
     */
    modes?: Array<DropMode>;
    /**
     * Free-form platform labels — "PS5", "Nintendo Switch 2".
     * @type {Array<string>}
     * @memberof Drop
     */
    platforms?: Array<string>;
    /**
     * Set once the subject exists in owgames; unlocks telemetry-based signals.
     * @type {string}
     * @memberof Drop
     */
    gameRef?: string;
    /**
     * Twitch categories this subject streams under. What "who is live in Call of Duty" matches on.
     * @type {Array<string>}
     * @memberof Drop
     */
    twitchGameIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Drop
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased title/tag aliases — the only signal available before a category exists.
     * @type {Array<string>}
     * @memberof Drop
     */
    streamTitleAliases?: Array<string>;
    /**
     * The subject's own Steam store app — drives the purchase link, and the news feed when steamNewsAppId is unset. Held here because a pre-release title has no game record; falls back to the linked game's id when gameRef is set.
     * @type {number}
     * @memberof Drop
     */
    steamAppId?: number;
    /**
     * The Steam app whose ANNOUNCEMENTS this subject posts to, when that differs from its store app — normal for a franchise title, where every game posts to one shared app. Falls back to steamAppId.
     * @type {number}
     * @memberof Drop
     */
    steamNewsAppId?: number;
    /**
     * Short credits line under the name — "Activision · Infinity Ward". Authored, unlike description, which the social parser fills with the channel bio.
     * @type {string}
     * @memberof Drop
     */
    creditLine?: string;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof Drop
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof Drop
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {SurfaceThemeConfig}
     * @memberof Drop
     */
    themeConfig?: SurfaceThemeConfig;
    /**
     * 
     * @type {SurfacePointSystemConfig}
     * @memberof Drop
     */
    pointSystemConfig?: SurfacePointSystemConfig;
    /**
     * 
     * @type {EarningConfigValues}
     * @memberof Drop
     */
    earningConfig?: EarningConfigValues;
    /**
     * Whether the surface owner may edit earning config
     * @type {boolean}
     * @memberof Drop
     */
    allowOwnerPointsConfig?: boolean;
    /**
     * Whether this workspace may author scoring programs (earn actions + boards) in the Devour Portal
     * @type {boolean}
     * @memberof Drop
     */
    allowProgramAuthoring?: boolean;
    /**
     * When true, this Drop serves the embedded hub slug the router maps to it. Off means the original hub still answers that url, so the code can ship before the cutover.
     * @type {boolean}
     * @memberof Drop
     */
    embedCutoverActive?: boolean;
    /**
     * When true, players on this partner surface are not asked for date of birth or username. Default false (required).
     * @type {boolean}
     * @memberof Drop
     */
    identityExempt?: boolean;
    /**
     * Admin user id who last changed identityExempt.
     * @type {string}
     * @memberof Drop
     */
    identityExemptBy?: string;
    /**
     * Unix ms when identityExempt was last changed.
     * @type {number}
     * @memberof Drop
     */
    identityExemptAt?: number;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof Drop
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof Drop
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * 
     * @type {PageSeo}
     * @memberof Drop
     */
    seo?: PageSeo;
    /**
     * Competition umbrella assigned to this Drop (same pattern as Hub)
     * @type {string}
     * @memberof Drop
     */
    competitionId?: string;
    /**
     * QuestConfig IDs assigned to this Drop (same pattern as Hub)
     * @type {Array<string>}
     * @memberof Drop
     */
    questConfigs?: Array<string>;
    /**
     * 
     * @type {LedgerOwner}
     * @memberof Drop
     */
    ledgerOwner?: LedgerOwner;
    /**
     * The Ledger this Drop's point-granting engagements credit. The reference form of ledgerOwner — an entity may own several ledgers. Empty string clears.
     * @type {string}
     * @memberof Drop
     */
    ledgerId?: string;
    /**
     * The OnboardingExperience this Drop runs at its door (T7) — branded login, identity provider, marketing default.
     * @type {string}
     * @memberof Drop
     */
    onboardingExperienceId?: string;
    /**
     * 
     * @type {Array<DropSection>}
     * @memberof Drop
     */
    sections?: Array<DropSection>;
    /**
     * 
     * @type {StreamingSettings}
     * @memberof Drop
     */
    streamingSettings?: StreamingSettings;
    /**
     * 
     * @type {Array<SurfaceContentBlock>}
     * @memberof Drop
     */
    contentBlocks?: Array<SurfaceContentBlock>;
    /**
     * Puck visual builder native JSON. Source of truth when useVisualBuilder is true.
     * @type {{ [key: string]: any; }}
     * @memberof Drop
     */
    pageBuilderData?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof Drop
     */
    useVisualBuilder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Drop
     */
    phase?: DropPhaseEnum;
    /**
     * Per-Drop game allowlist — mirrors Hub.allowedGames semantics.
     * @type {Array<SurfaceAllowedGame>}
     * @memberof Drop
     */
    allowedGames?: Array<SurfaceAllowedGame>;
    /**
     * Reference to standalone StreamingTeam (mirrors Hub.streamingTeamId).
     * @type {string}
     * @memberof Drop
     */
    streamingTeamId?: string;
    /**
     * Roster card fields THIS surface adds over its team's schema, merged by key. The schema proper lives on the team, because a team is shared; this is the scoped exception for a surface that wants one extra field without forking the team.
     * @type {Array<RosterFieldSpec>}
     * @memberof Drop
     */
    rosterFields?: Array<RosterFieldSpec>;
    /**
     * Access prerequisites — all must be satisfied. Mirrors Hub.prerequisites.
     * @type {Array<Prerequisite>}
     * @memberof Drop
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * Creator storefront link-outs surfaced on the Drop page. Parser-detected + USER-added entries coexist.
     * @type {Array<DropStorefront>}
     * @memberof Drop
     */
    storefronts?: Array<DropStorefront>;
    /**
     * Games derived from competitions + social profiles (computed at route time, not stored).
     * @type {Array<DerivedGameResponse>}
     * @memberof Drop
     */
    derivedGames?: Array<DerivedGameResponse>;
    /**
     * Follower count for this Drop (cached, computed at route time).
     * @type {number}
     * @memberof Drop
     */
    followerCount?: number;
    /**
     * 
     * @type {SurfaceMeta}
     * @memberof Drop
     */
    seoMeta?: SurfaceMeta;
    /**
     * Whether this Drop is publicly listed, as decided by `isListed` at route time. Returned so consumers that cannot import the rule (web/server.js) read the answer instead of re-deriving it.
     * @type {boolean}
     * @memberof Drop
     */
    isListed?: boolean;
    /**
     * 
     * @type {DropRelease}
     * @memberof Drop
     */
    release?: DropRelease;
    /**
     * Time-boxed windows in which marker-carrying co-streams count as on-game.
     * @type {Array<DropCampaignWindow>}
     * @memberof Drop
     */
    campaignWindows?: Array<DropCampaignWindow>;
    /**
     * POV this Drop was created as (CREATOR, PUBLISHER, FRANCHISE, GAME, BRAND, COMMUNITY, ESPORTS_PROFESSIONAL, ESPORTS_COLLEGIATE, AGENCY). Drives which editor blocks are shown.
     * @type {string}
     * @memberof Drop
     */
    pov?: string;
    /**
     * The Drop this one hangs off. A title points at its franchise; a franchise points at its publisher.
     * @type {string}
     * @memberof Drop
     */
    parentDropId?: string;
    /**
     * The parent's display name, resolved at route time.
     * @type {string}
     * @memberof Drop
     */
    parentDropName?: string;
    /**
     * The parent's slug. Omitted when the parent is not publicly viewable — a parent may exist only to group its children.
     * @type {string}
     * @memberof Drop
     */
    parentDropSlug?: string;
    /**
     * Other Drops under the same parent (computed at route time, not stored).
     * @type {Array<DropSiblingTitle>}
     * @memberof Drop
     */
    siblingTitles?: Array<DropSiblingTitle>;
    /**
     * Drops hanging off this one — a franchise's own titles (computed at route time, not stored).
     * @type {Array<DropSiblingTitle>}
     * @memberof Drop
     */
    childTitles?: Array<DropSiblingTitle>;
}


/**
 * @export
 */
export const DropOwnerTypeEnum = {
    user: 'user',
    organization: 'organization'
} as const;
export type DropOwnerTypeEnum = typeof DropOwnerTypeEnum[keyof typeof DropOwnerTypeEnum];

/**
 * @export
 */
export const DropEntityTypeEnum = {
    BRAND: 'BRAND'
} as const;
export type DropEntityTypeEnum = typeof DropEntityTypeEnum[keyof typeof DropEntityTypeEnum];

/**
 * @export
 */
export const DropPhaseEnum = {
    pre_launch: 'pre_launch',
    live: 'live'
} as const;
export type DropPhaseEnum = typeof DropPhaseEnum[keyof typeof DropPhaseEnum];


/**
 * Check if a given object implements the Drop interface.
 */
export function instanceOfDrop(value: object): value is Drop {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('dropType' in value) || value['dropType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function DropFromJSON(json: any): Drop {
    return DropFromJSONTyped(json, false);
}

export function DropFromJSONTyped(json: any, ignoreDiscriminator: boolean): Drop {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'slug': json['slug'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'dropType': DropTypeFromJSON(json['dropType']),
        'status': SurfaceStatusFromJSON(json['status']),
        'visibility': json['visibility'] == null ? undefined : SurfaceVisibilityFromJSON(json['visibility']),
        'isStandalone': json['isStandalone'] == null ? undefined : json['isStandalone'],
        'distributions': json['distributions'] == null ? undefined : ((json['distributions'] as Array<any>).map(DistributionFromJSON)),
        'verified': json['verified'] == null ? undefined : json['verified'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerType': json['ownerType'] == null ? undefined : json['ownerType'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'shopMerchantId': json['shopMerchantId'] == null ? undefined : json['shopMerchantId'],
        'games': json['games'] == null ? undefined : json['games'],
        'socials': json['socials'] == null ? undefined : ((json['socials'] as Array<any>).map(SurfaceSocialConnectionFromJSON)),
        'creatorProfileImageUrl': json['creatorProfileImageUrl'] == null ? undefined : json['creatorProfileImageUrl'],
        'creatorProfileImageManualOverride': json['creatorProfileImageManualOverride'] == null ? undefined : json['creatorProfileImageManualOverride'],
        'creatorHeaderImageUrl': json['creatorHeaderImageUrl'] == null ? undefined : json['creatorHeaderImageUrl'],
        'creatorHeaderImageManualOverride': json['creatorHeaderImageManualOverride'] == null ? undefined : json['creatorHeaderImageManualOverride'],
        'lastVodThumbnailUrl': json['lastVodThumbnailUrl'] == null ? undefined : json['lastVodThumbnailUrl'],
        'iconImageId': json['iconImageId'] == null ? undefined : json['iconImageId'],
        'logoImageId': json['logoImageId'] == null ? undefined : json['logoImageId'],
        'logoImageUrl': json['logoImageUrl'] == null ? undefined : json['logoImageUrl'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'programName': json['programName'] == null ? undefined : json['programName'],
        'memberStatLabel': json['memberStatLabel'] == null ? undefined : json['memberStatLabel'],
        'memberStatDetail': json['memberStatDetail'] == null ? undefined : json['memberStatDetail'],
        'memberCount': json['memberCount'] == null ? undefined : json['memberCount'],
        'synopsis': json['synopsis'] == null ? undefined : json['synopsis'],
        'purchaseUrl': json['purchaseUrl'] == null ? undefined : json['purchaseUrl'],
        'trailerUrl': json['trailerUrl'] == null ? undefined : json['trailerUrl'],
        'videos': json['videos'] == null ? undefined : ((json['videos'] as Array<any>).map(DropVideoFromJSON)),
        'modes': json['modes'] == null ? undefined : ((json['modes'] as Array<any>).map(DropModeFromJSON)),
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'gameRef': json['gameRef'] == null ? undefined : json['gameRef'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'steamNewsAppId': json['steamNewsAppId'] == null ? undefined : json['steamNewsAppId'],
        'creditLine': json['creditLine'] == null ? undefined : json['creditLine'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'themeConfig': json['themeConfig'] == null ? undefined : SurfaceThemeConfigFromJSON(json['themeConfig']),
        'pointSystemConfig': json['pointSystemConfig'] == null ? undefined : SurfacePointSystemConfigFromJSON(json['pointSystemConfig']),
        'earningConfig': json['earningConfig'] == null ? undefined : EarningConfigValuesFromJSON(json['earningConfig']),
        'allowOwnerPointsConfig': json['allowOwnerPointsConfig'] == null ? undefined : json['allowOwnerPointsConfig'],
        'allowProgramAuthoring': json['allowProgramAuthoring'] == null ? undefined : json['allowProgramAuthoring'],
        'embedCutoverActive': json['embedCutoverActive'] == null ? undefined : json['embedCutoverActive'],
        'identityExempt': json['identityExempt'] == null ? undefined : json['identityExempt'],
        'identityExemptBy': json['identityExemptBy'] == null ? undefined : json['identityExemptBy'],
        'identityExemptAt': json['identityExemptAt'] == null ? undefined : json['identityExemptAt'],
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'questConfigs': json['questConfigs'] == null ? undefined : json['questConfigs'],
        'ledgerOwner': json['ledgerOwner'] == null ? undefined : LedgerOwnerFromJSON(json['ledgerOwner']),
        'ledgerId': json['ledgerId'] == null ? undefined : json['ledgerId'],
        'onboardingExperienceId': json['onboardingExperienceId'] == null ? undefined : json['onboardingExperienceId'],
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(DropSectionFromJSON)),
        'streamingSettings': json['streamingSettings'] == null ? undefined : StreamingSettingsFromJSON(json['streamingSettings']),
        'contentBlocks': json['contentBlocks'] == null ? undefined : ((json['contentBlocks'] as Array<any>).map(SurfaceContentBlockFromJSON)),
        'pageBuilderData': json['pageBuilderData'] == null ? undefined : json['pageBuilderData'],
        'useVisualBuilder': json['useVisualBuilder'] == null ? undefined : json['useVisualBuilder'],
        'phase': json['phase'] == null ? undefined : json['phase'],
        'allowedGames': json['allowedGames'] == null ? undefined : ((json['allowedGames'] as Array<any>).map(SurfaceAllowedGameFromJSON)),
        'streamingTeamId': json['streamingTeamId'] == null ? undefined : json['streamingTeamId'],
        'rosterFields': json['rosterFields'] == null ? undefined : ((json['rosterFields'] as Array<any>).map(RosterFieldSpecFromJSON)),
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'storefronts': json['storefronts'] == null ? undefined : ((json['storefronts'] as Array<any>).map(DropStorefrontFromJSON)),
        'derivedGames': json['derivedGames'] == null ? undefined : ((json['derivedGames'] as Array<any>).map(DerivedGameResponseFromJSON)),
        'followerCount': json['followerCount'] == null ? undefined : json['followerCount'],
        'seoMeta': json['seoMeta'] == null ? undefined : SurfaceMetaFromJSON(json['seoMeta']),
        'isListed': json['isListed'] == null ? undefined : json['isListed'],
        'release': json['release'] == null ? undefined : DropReleaseFromJSON(json['release']),
        'campaignWindows': json['campaignWindows'] == null ? undefined : ((json['campaignWindows'] as Array<any>).map(DropCampaignWindowFromJSON)),
        'pov': json['pov'] == null ? undefined : json['pov'],
        'parentDropId': json['parentDropId'] == null ? undefined : json['parentDropId'],
        'parentDropName': json['parentDropName'] == null ? undefined : json['parentDropName'],
        'parentDropSlug': json['parentDropSlug'] == null ? undefined : json['parentDropSlug'],
        'siblingTitles': json['siblingTitles'] == null ? undefined : ((json['siblingTitles'] as Array<any>).map(DropSiblingTitleFromJSON)),
        'childTitles': json['childTitles'] == null ? undefined : ((json['childTitles'] as Array<any>).map(DropSiblingTitleFromJSON)),
    };
}

export function DropToJSON(json: any): Drop {
    return DropToJSONTyped(json, false);
}

export function DropToJSONTyped(value?: Drop | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'slug': value['slug'],
        'name': value['name'],
        'description': value['description'],
        'dropType': DropTypeToJSON(value['dropType']),
        'status': SurfaceStatusToJSON(value['status']),
        'visibility': SurfaceVisibilityToJSON(value['visibility']),
        'isStandalone': value['isStandalone'],
        'distributions': value['distributions'] == null ? undefined : ((value['distributions'] as Array<any>).map(DistributionToJSON)),
        'verified': value['verified'],
        'ownerId': value['ownerId'],
        'ownerType': value['ownerType'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'shopMerchantId': value['shopMerchantId'],
        'games': value['games'],
        'socials': value['socials'] == null ? undefined : ((value['socials'] as Array<any>).map(SurfaceSocialConnectionToJSON)),
        'creatorProfileImageUrl': value['creatorProfileImageUrl'],
        'creatorProfileImageManualOverride': value['creatorProfileImageManualOverride'],
        'creatorHeaderImageUrl': value['creatorHeaderImageUrl'],
        'creatorHeaderImageManualOverride': value['creatorHeaderImageManualOverride'],
        'lastVodThumbnailUrl': value['lastVodThumbnailUrl'],
        'iconImageId': value['iconImageId'],
        'logoImageId': value['logoImageId'],
        'logoImageUrl': value['logoImageUrl'],
        'tagline': value['tagline'],
        'programName': value['programName'],
        'memberStatLabel': value['memberStatLabel'],
        'memberStatDetail': value['memberStatDetail'],
        'memberCount': value['memberCount'],
        'synopsis': value['synopsis'],
        'purchaseUrl': value['purchaseUrl'],
        'trailerUrl': value['trailerUrl'],
        'videos': value['videos'] == null ? undefined : ((value['videos'] as Array<any>).map(DropVideoToJSON)),
        'modes': value['modes'] == null ? undefined : ((value['modes'] as Array<any>).map(DropModeToJSON)),
        'platforms': value['platforms'],
        'gameRef': value['gameRef'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'streamTitleAliases': value['streamTitleAliases'],
        'steamAppId': value['steamAppId'],
        'steamNewsAppId': value['steamNewsAppId'],
        'creditLine': value['creditLine'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'themeConfig': SurfaceThemeConfigToJSON(value['themeConfig']),
        'pointSystemConfig': SurfacePointSystemConfigToJSON(value['pointSystemConfig']),
        'earningConfig': EarningConfigValuesToJSON(value['earningConfig']),
        'allowOwnerPointsConfig': value['allowOwnerPointsConfig'],
        'allowProgramAuthoring': value['allowProgramAuthoring'],
        'embedCutoverActive': value['embedCutoverActive'],
        'identityExempt': value['identityExempt'],
        'identityExemptBy': value['identityExemptBy'],
        'identityExemptAt': value['identityExemptAt'],
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'seo': PageSeoToJSON(value['seo']),
        'competitionId': value['competitionId'],
        'questConfigs': value['questConfigs'],
        'ledgerOwner': LedgerOwnerToJSON(value['ledgerOwner']),
        'ledgerId': value['ledgerId'],
        'onboardingExperienceId': value['onboardingExperienceId'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(DropSectionToJSON)),
        'streamingSettings': StreamingSettingsToJSON(value['streamingSettings']),
        'contentBlocks': value['contentBlocks'] == null ? undefined : ((value['contentBlocks'] as Array<any>).map(SurfaceContentBlockToJSON)),
        'pageBuilderData': value['pageBuilderData'],
        'useVisualBuilder': value['useVisualBuilder'],
        'phase': value['phase'],
        'allowedGames': value['allowedGames'] == null ? undefined : ((value['allowedGames'] as Array<any>).map(SurfaceAllowedGameToJSON)),
        'streamingTeamId': value['streamingTeamId'],
        'rosterFields': value['rosterFields'] == null ? undefined : ((value['rosterFields'] as Array<any>).map(RosterFieldSpecToJSON)),
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'storefronts': value['storefronts'] == null ? undefined : ((value['storefronts'] as Array<any>).map(DropStorefrontToJSON)),
        'derivedGames': value['derivedGames'] == null ? undefined : ((value['derivedGames'] as Array<any>).map(DerivedGameResponseToJSON)),
        'followerCount': value['followerCount'],
        'seoMeta': SurfaceMetaToJSON(value['seoMeta']),
        'isListed': value['isListed'],
        'release': DropReleaseToJSON(value['release']),
        'campaignWindows': value['campaignWindows'] == null ? undefined : ((value['campaignWindows'] as Array<any>).map(DropCampaignWindowToJSON)),
        'pov': value['pov'],
        'parentDropId': value['parentDropId'],
        'parentDropName': value['parentDropName'],
        'parentDropSlug': value['parentDropSlug'],
        'siblingTitles': value['siblingTitles'] == null ? undefined : ((value['siblingTitles'] as Array<any>).map(DropSiblingTitleToJSON)),
        'childTitles': value['childTitles'] == null ? undefined : ((value['childTitles'] as Array<any>).map(DropSiblingTitleToJSON)),
    };
}

